<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-card
            shadow="hover">
          <el-row>
            <el-col
                :span="8"
                style="text-align: -webkit-left">
              <div class="card-header">
                <h3>Users</h3>
              </div>
            </el-col>
            <el-col
                :span="16"
                style="text-align: -webkit-right">
              <input
                  ref="bulkSetPermissionFile"
                  type="file"
                  accept="text/csv"
                  style="display: none"
                  @change="onUsersFileSelected">
              <el-tooltip
                  content="Assign Permission to Multiple Users at once"
                  placement="right">
                <el-button
                    type="primary"
                    plain
                    style="margin-top: 5px"
                    @click="addBulkItems({entity: 'users'})">
                  Upload File
                </el-button>
              </el-tooltip>
              <template>
                <div class="el-upload__tip">
                  .csv file with upto 150 emails <el-tooltip>
                    <div slot="content">
                      File must include required headers (columns):
                      <ol style="padding-left: 15px">
                        <li>email: user email or user id to be assigned permission to</li>
                        <li>action: can have values "assign" or "unassign"</li>
                      </ol>
                      Headers are case insensitive but ordered i.e. first header must be email and second action.
                    </div>
                    <i class="el-icon-info" />
                  </el-tooltip>
                </div>
              </template>
            </el-col>
          </el-row>
          <div class="card-body">
            <div>
              <el-row
                  style="border: dotted; border-radius: 5px; color: rgb(202, 202, 202);margin: 20px 0px 20px 0px">
                <form
                    :model="form"
                    :disabled="!form.name"
                    @submit.prevent="addItem( { entity: 'users', email: form.name })">
                  <el-col
                      :span="4"
                      style="text-align: -webkit-center">
                    <p> Add User </p>
                  </el-col>
                  <el-col
                      :span="16"
                      style="margin-top: 5px">
                    <el-input
                        v-model="form.name"
                        required
                        placeholder="Input user or email"
                        input="string"
                        style="max-width: 400px;" />
                  </el-col>
                  <el-col
                      :span="4">
                    <el-tooltip
                        content="Add User"
                        placement="right">
                      <el-button
                          type="primary"
                          plain
                          style="margin-top: 5px"
                          :disabled="!form.name"
                          @click="addItem({ entity: 'users', email: form.name })">
                        <i class="el-icon-plus"></i>
                      </el-button>
                    </el-tooltip>
                  </el-col>
                </form>
              </el-row>
              <div style="margin-top: 0px">
              </div>
            </div>
          </div>
          <div
              class="card-footer"
              style="height: 240px; overflow-y: scroll">
            <el-table
                :data="permission.users.entries"
                class="permissions-table-style">
              <el-table-column
                  :min-width="40"
                  prop="type"
                  label="Email">
                <template slot-scope="scope">
                  {{ scope.row.email }}
                </template>
              </el-table-column>
              <el-table-column
                  :min-width="45"
                  prop="type"
                  label="Name">
                <template slot-scope="scope">
                  {{ scope.row.last_name }}, {{ scope.row.first_name }}
                </template>
              </el-table-column>
              <el-table-column
                  :min-width="15"
                  label="Action">
                <template slot-scope="scope">
                  <el-tooltip
                      content="Remove User"
                      placement="right">
                    <span
                        class="icon-row"
                        @click="OpenRemoveItemDialog('users', scope.row.id)">
                      <font-awesome-icon
                          icon="trash"
                          style="margin-left: 15px" /></span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card
            shadow="hover">
          <div class="card-header">
            <h3>Roles</h3>
          </div>
          <div class="card-body">
            <div>
              <el-row
                  style="border: dotted; border-radius: 5px; color: rgb(202, 202, 202);margin: 20px 0px 20px 0px">
                <el-col
                    :span="4"
                    style="text-align: -webkit-center">
                  <p> Add Role </p>
                </el-col>
                <el-col
                    :span="16"
                    style="margin-top: 5px">
                  <el-select
                      v-model="currentRole"
                      placeholder="Select a role"
                      required
                      @change="selectRole">
                    <el-option
                        v-for="item in allowedRoles"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id" />
                  </el-select>
                </el-col>
                <el-col
                    :span="4">
                  <el-tooltip
                      content="Add Role"
                      placement="right">
                    <el-button
                        type="primary"
                        plain
                        style="margin-top: 5px"
                        :disabled="!selectedRole"
                        @click="addItem({ entity: 'roles' })">
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-tooltip>
                </el-col>
              </el-row>
              <div style="margin-top: 0px">
              </div>
            </div>
          </div>
          <div class="card-footer">
            <el-table
                :data="permission.roles"
                class="permissions-table-style">
              <el-table-column
                  :min-width="80"
                  prop="type"
                  label="Role">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column
                  :min-width="15"
                  prop="type"
                  label="Action">
                <template slot-scope="scope">
                  <el-tooltip
                      content="Remove Role"
                      placement="right">
                    <span
                        class="icon-row"
                        @click="OpenRemoveItemDialog('roles', scope.row.id)">
                      <font-awesome-icon
                          icon="trash"
                          style="margin-left: 15px" /></span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
        :title="'Remove ' + action "
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="true">
      <img
          :src="icons.warning"
          class="icon">
      <span class="dialog_title_style">Remove {{ action.slice(0, -1) }} assigned to permission?</span>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            @click="removeItem();">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="Unsuccessful Permission Requests"
        :visible.sync="unsuccessfulDialogVisible">
      <el-table
          :data="unsuccessfulBulkRequests"
          style="margin: 20px">
        <el-table-column
            property="email"
            label="Email"
            width="200" />
        <el-table-column
            property="action"
            label="Action"
            width="100" />
        <el-table-column
            property="error"
            width="600"
            label="Error" />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { startCase } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");
export default {
  name: "PermissionDetails",
  props: { permission: { type: Object, default: () => {} } },
  data() {
    return {
      roleOptions: [],
      currentRole: "",
      selectedRole: "",
      form: { name: null },
      dialogVisible: false,
      action: "",
      item_id: 0,
      email: "",
      bulkSetPermissionFile: "",
      successfulBulkRequests: [],
      unsuccessfulBulkRequests: [],
      unsuccessfulDialogVisible: false,
      icons: {
        warning: require("@/assets/icons/new-ui/customer/authorizations/shared/warning.svg"),
      },
    };
  },
  computed: {
    ...sharedGetters(["roles"]),
    allowedRoles() {
      let currentIds = this.permission.roles.map((r) => r.id);
      let roles = this.roleOptions.filter(
        (role) => currentIds.indexOf(Number(role.id)) == -1
      );
      return roles;
    },
  },
  created() {
    this.roleOptions = this.roles.roles.map((item) => {
      return { id: `${item.id}`, value: `${item.name}`, label: `${item.name}` };
    });
    //Remove "None" option role (index 0)
    this.roleOptions.shift();
  },
  methods: {
    selectRole(val) {
      this.selectedRole = val;
    },
    loadInitialState() {
      this.form = { name: "", file: "" };
      this.dialogVisible = false;
      this.selectedRole = "";
      this.currentRole = "";
      this.action = "";
      this.email = "";
      this.item_id = 0;
      this.form = { name: "" };
    },
    isValidEmailOrUser(input_text) {
      let validEmail =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      let validUser = /^[a-zA]*$/;
      let valid_text =
        input_text.match(validEmail) || input_text.match(validUser);
      if (valid_text == null) {
        return false;
      } else {
        let valid = valid_text.input != "" ? true : false;
        return valid;
      }
    },
    assignedUser(user) {
      let params = { email: user };
      let alreadyAdded = this.permission.users.entries.find(function (user) {
        return (
          user.email.split("@")[0] === params.email ||
          user.email === params.email
        );
      });
      return alreadyAdded;
    },
    addItem(args) {
      let payload =
        args["entity"] === "users"
          ? { email: args["email"] }
          : { role_id: this.selectedRole };
      if (args["email"]) {
        if (this.assignedUser(args["email"].toLowerCase())) {
          this.$message({
            title: "Error",
            message: "User already added",
            type: "error",
          });
          return;
        } else if (
          args["entity"] === "users" &&
          !this.isValidEmailOrUser(args["email"].toLowerCase())
        ) {
          this.$message({
            title: "Error",
            message: "Please enter a valid user or email address!",
            type: "error",
          });
          return;
        }
      }
      return axios
        .post(`v3/permissions/${this.permission.id}/${args["entity"]}`, payload)
        .then((response) => {
          this.$message({
            title: "Success",
            message: `${startCase(args["entity"].slice(0, -1))} added`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message:
              error.data.message != undefined
                ? error.data.message
                : `${startCase(args["entity"].slice(0, -1))} already added`,
            type: "error",
          });
        })
        .finally(() => {
          this.loadInitialState();
          this.$emit("reload");
        });
    },
    removeItem() {
      let payload =
        this.action === "roles"
          ? { role_id: this.item_id }
          : { user_id: this.item_id };
      axios
        .delete(`/v3/permissions/${this.permission.id}/${this.action}`, {
          data: payload,
        })
        .then(() => {
          this.$message({
            title: "Success",
            message: `${startCase(this.action.slice(0, -1))} removed`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message: "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => {
          this.dialogVisible = false;
          this.$emit("reload");
        });
    },
    OpenRemoveItemDialog(action, item_id) {
      this.action = action;
      this.item_id = item_id;
      this.dialogVisible = true;
    },
    addBulkItems(item) {
      if (item.entity === "users") {
        this.$refs.bulkSetPermissionFile.click();
      }
    },
    onUsersFileSelected(event) {
      const files = this.$refs.bulkSetPermissionFile.files;
      if (files.length !== 1) {
        if (files.length < 1) {
          this.$message({
            title: "Error",
            message: "No file selected",
            type: "error",
          });
        } else {
          this.$message({
            title: "Error",
            message: "Select only one file",
            type: "error",
          });
        }
      } else {
        this.bulkSetPermissionFile = files[0];
        this.sendFile();
        this.$refs.bulkSetPermissionFile.value = "";
      }
    },
    sendFile() {
      let formData = new FormData();
      formData.append("file", this.bulkSetPermissionFile);
      let reader = new FileReader();
      reader.readAsText(this.bulkSetPermissionFile, "UTF-8");
      reader.onload = (evt) => {
        let text = evt.target.result;
        let rows = text.split(/\r?\n/);
        if (rows.length > 0) {
          if (rows[rows.length - 1] === "") rows.pop();
          let headers = rows[0].split(",");
          if (
            this.check_headers(headers) &&
            this.check_row_limit(rows.length)
          ) {
            return axios
              .post(
                `v3/permissions/${this.permission.id}/bulk_users`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              )
              .then((response) => {
                this.unsuccessfulBulkRequests = response.data.unsuccessful;
                this.successfulBulkRequests = response.data.successful;
                if (this.unsuccessfulBulkRequests.length > 0) {
                  this.unsuccessfulDialogVisible = true;
                } else {
                  if (this.successfulBulkRequests.length > 0) {
                    this.$message({
                      title: "Success",
                      message: `All user permissions set successfully!`,
                      type: "success",
                    });
                  }
                }
              })
              .catch((error) => {
                this.unsuccessfulBulkRequests = error.data.failures;
                this.$message({
                  title: "Error",
                  message:
                    error.data.message != undefined
                      ? error.data.message
                      : `Something went wrong! Try again.`,
                  type: "error",
                });
                this.unsuccessfulDialogVisible = true;
              })
              .finally(() => {
                this.loadInitialState();
                this.$emit("reload");
              });
          }
        } else {
          this.$message({
            title: "Error",
            message: "File is empty!",
            type: "error",
          });
        }
      };
    },
    check_headers(headers) {
      if (
        headers[0].trim().toLowerCase() === "email" &&
        headers[1].trim().toLowerCase() === "action"
      ) {
        return true;
      } else {
        this.$message({
          title: "Error",
          message: "Incorrect CSV headers.",
          type: "error",
        });
        return false;
      }
    },
    check_row_limit(len) {
      if (len <= 151) {
        return true;
      } else {
        this.$message({
          title: "Error",
          message: "File exceeds limit on number of rows.",
          type: "error",
        });
        return false;
      }
    },
  },
};
</script>
